import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function SubjectInfo() {
  const { classId, subject } = useParams();
  const { token } = useAuth();
  const [info, setInfo] = useState<any>(null);
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>('');

  useEffect(() => {
    async function fetchSubjectInfo() {
      setLoading(true);
      setError('');
      try {
        const res = await fetch(`/api/classes/${classId}/subjects/${subject}/info`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!res.ok) throw new Error('Failed to fetch subject info');
        const data = await res.json();
        setInfo(data.info || null);
      } catch (err: any) {
        setError('Could not load subject info.');
      } finally {
        setLoading(false);
      }
    }
    if (token && classId && subject) fetchSubjectInfo();
  }, [classId, subject, token]);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Subject Information</h1>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div className="text-red-600">{error}</div>
      ) : info ? (
        <>
          <h2 className="font-semibold mb-2">{info.title || subject}</h2>
          <p>{info.description || 'No description available.'}</p>
          {info.resources && info.resources.length > 0 && (
            <div className="mt-4">
              <h3 className="font-semibold mb-1">Resources</h3>
              <ul className="list-disc ml-6">
                {info.resources.map((r, i) => <li key={i}><a href={r.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">{r.name}</a></li>)}
              </ul>
            </div>
          )}
        </>
      ) : (
        <div>No subject info found.</div>
      )}
    </div>
  );
}
